import React from 'react'

const ToDoList = ({ items = [], handleRemove }) => (
  <ul>
    {items.map((item) => (
      <li key={item.id}>
        {item.text}{' '}
        <span
          style={{ color: 'red', paddingLeft: '1em', cursor: 'pointer' }}
          onClick={handleRemove(item.id)}
        >
          X
        </span>
      </li>
    ))}
  </ul>
)
export default ToDoList
